<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>绝当订单 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>
      <div class="head_right">
        <span>绝当订单总数：{{ len }}</span>
      </div>
    </div>
     <!-- 这是数据看板栏 -->
    <div class="contai_sj">
      <div class="cont_co">
        <div class="conta_box">
          <span class="con_text">绝当订单数：{{ len }}</span>
        </div>
        <div class="conta_box">
          <span class="con_text">绝当总金额：{{ price }}元</span>
        </div>
        
      </div>
    </div>

      <!-- 这是列表栏 -->
    <div class="contai_li">
      <el-table :data="this.items" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="当户姓名：">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="联系电话"
                >:
                <span>{{ props.row.telephone }}</span>
              </el-form-item>
              <el-form-item label="典当物品"
                >:
                <span>{{ props.row.itemlb }}</span>
              </el-form-item>
              <el-form-item :label="props.row.nf"
                >:
                <span>{{ props.row.attrsx }}</span>
              </el-form-item>
              <el-form-item :label="props.row.zl"
                >:
                <span>{{ props.row.typezl }}</span>
              </el-form-item>
              <el-form-item :label="props.row.weight"
                >:
                <span>{{ props.row.itemattsx }}</span>
              </el-form-item>
              <el-form-item label="典当周期"
                >:
                <span>{{ props.row.mode }}天</span>
              </el-form-item>
              <el-form-item label="典当价格"
                >:
                <span>{{ props.row.price }}元</span>
              </el-form-item>
              <el-form-item label="开始日期"
                >:
                <span>{{ props.row.date }}</span>
              </el-form-item>
              <el-form-item label="结束日期"
                >:
                <span>{{ props.row.preFinishedDate }}</span>
              </el-form-item>
              <el-form-item label="鉴定方式"
                >:
                <span>{{ props.row.mod }}</span>
              </el-form-item>
              <el-form-item label="当品描述"
                >:
                <span>{{ props.row.descrms }}</span>
              </el-form-item>
              <el-form-item label="典当状态"
                >:
                <span>{{ props.row.state }}</span>
              </el-form-item>
              <el-form-item label="收货地址"
                >:
                <span>{{ props.row.sfdz }}</span>
              </el-form-item>
              <el-form-item label="收款开户行"
                >:
                <span>{{ props.row.userinfo }}</span>
              </el-form-item>
              <el-form-item label="收款银行账号"
                >:
                <span>{{ props.row.userbank }}</span>
              </el-form-item>
              <el-form-item label="证件号码"
                >:
                <span>{{ props.row.idcard }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="当户" prop="name"> </el-table-column>
        <el-table-column
          prop="date"
          label="开始日期"
          sortable
          column-key="date"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column label="结束日期" prop="preFinishedDate">
        </el-table-column>
        <el-table-column label="典当物品" prop="itemlb"> </el-table-column>
        <el-table-column label="典当状态" prop="state"> </el-table-column>
        <el-table-column label="赎回金额/元" prop="price"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Absolutely",

  data() {
    return {
      deta: "", //获取到今天的日期
      len: "", //获取到的
      ACCESS_TOKEN: "", //拿到ACCESS_TOKEN
      price:"",  //存储计算好的绝当总金额
      typeda:"", //最多绝当的物品
      items:[],   //所有绝当数据
    };
  },

 methods: {
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
   
  },
  created(){
    //获取ACCESS_TOKEN
    this.getTokens()

    //获取当前登录的用户信息
    this.getUserToken()
  },

  mounted() {
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");

      setTimeout(()=>{
           //请求绝当订单
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query:
          'db.collection("user_ddxx").where({state:"绝当"}).limit(1000).get()',
      })
      .then((aa) => {
        if(aa.data.errcode !==0){
          return this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
        }
        aa.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = aa.data.data;
        this.len = aa.data.data.length;

        //循环计算绝当的总金额
        let str = "";
        for (let i in this.items) {
          str += this.items[i].price;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.price = eval(str);

      });
      },800)
 

    
  },
};
</script>
<style scoped>
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}
.haed_cont {
  font-size: 20px;
}
.head_right {
  margin: 13px 50px;
  font-size: 20px;
}
.contai_sj {
  width: 100%;
  height: 150px;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 10px;
}
.cont_co {
  display: flex;
  flex-direction: row;
}
.conta_box {
  width: 350px;
  height: 120px;
  background-color: #a9d463;
  border-radius: 15px;
  margin: 16px 50px;
}
.con_text {
  color: #ffffff;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 37px 0;
}
.contai_li {
  width: 100%;
  background-color: #ffffff;
  margin: 10px 0;
  /* border-radius: 15px; */
}
/*列表样式 */
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 25%;
}
</style>